import { getActivePageConfigs } from '~/helpers/pageConfig/getActivePageConfigs'

export function getFirstActivePageConfig(
  pageConfigs: any[],
  now: any = new Date()
): any | null {
  return getActivePageConfigs(pageConfigs, now)?.[0] || null
}
